import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BRAND } from '../lib/api';

const links = [
  { to: '/', label: 'Search' },
  { to: '/reports', label: 'My reports' },
  { to: '/contact', label: 'Help' },
];

export function Shell({ children, narrow }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen flex flex-col relative">
      <div className="page-glow" aria-hidden />
      <header className="sticky top-0 z-40 border-b border-white/50 bg-white/70 backdrop-blur-lg">
        <div className="mx-auto max-w-3xl px-4 py-3.5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-brand to-accent text-white text-xs font-bold shadow-sm">
              ZM
            </span>
            <span className="text-lg font-bold text-ink group-hover:text-brand-dark transition-colors">
              {BRAND}
            </span>
          </Link>
          <nav className="flex gap-1 sm:gap-2 text-sm">
            {links.map((l) => {
              const active = pathname === l.to;
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className={`rounded-lg px-3 py-1.5 transition-colors ${
                    active
                      ? 'bg-brand/10 font-semibold text-brand-dark'
                      : 'text-muted hover:text-ink hover:bg-white/60'
                  }`}
                >
                  {l.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </header>
      <main className={`relative z-10 flex-1 mx-auto w-full px-4 py-8 sm:py-12 ${narrow ? 'max-w-lg' : 'max-w-3xl'}`}>
        {children}
      </main>
      <footer className="relative z-10 border-t border-white/60 bg-white/50 backdrop-blur-sm py-6 text-center text-xs text-muted">
        <p className="font-medium text-ink/70">© {new Date().getFullYear()} {BRAND}</p>
        <p className="mt-1.5">
          <Link to="/privacy" className="hover:text-brand transition-colors">Privacy</Link>
          {' · '}
          <Link to="/terms" className="hover:text-brand transition-colors">Terms</Link>
        </p>
      </footer>
    </div>
  );
}

export function Spinner() {
  return (
    <div className="flex justify-center py-12">
      <div className="h-9 w-9 animate-spin rounded-full border-2 border-brand/30 border-t-brand" />
    </div>
  );
}
